import { Cookies } from 'react-cookie';

import { COOKIE_CONSTANTS } from '../constants';

const cookies = new Cookies();

export function getReferrerFromCookie(): string | null {
  const result = cookies.get(COOKIE_CONSTANTS.REFERRER_COOKIE_NAME) || null;
  if (result) {
    console.debug(`Referrer cookie found: ${result}`);
  }

  return result;
}

export function setReferrerCookie(referrer: string): void {
  if (getReferrerFromCookie()) {
    console.debug('Referrer cookie already set, skipping update');
    return;
  }

  const cookieName = COOKIE_CONSTANTS.REFERRER_COOKIE_NAME;
  cookies.set(cookieName, referrer, {
    expires: new Date(COOKIE_CONSTANTS.REFERRER_COOKIE_EXPIRY),
    path: '/',
    sameSite: 'lax',
  });

  console.debug(`Referrer cookie set: ${cookieName}=${referrer}`);
}
